import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import Button from "../../components/Button";
import article_img_1 from "../../images/articles/knuckles-2569234_1920.jpg";

function ErDinBedriftKlar() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.eaa.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.eaa.description")}
        />
        <link rel="canonical" href="https://xperconsulting.no/artikler/er-din-bedrift-klar" />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left  ">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.eaa.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.eaa.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.eaa.date")}
          </p>
        </div>
        <img
          src={article_img_1}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.eaa.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className=" max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.eaa.sections.what.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.eaa.sections.what.content1")}</p>
            <p>{i18next.t("pages.articles.list.eaa.sections.what.content2")}</p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.eaa.sections.why.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.eaa.sections.why.content")}</p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t(
                "pages.articles.list.eaa.sections.startFromScratch.title"
              )}
            </h2>
            <p>
              {i18next.t(
                "pages.articles.list.eaa.sections.startFromScratch.contentBefore"
              )}
              <strong>
                {i18next.t(
                  "pages.articles.list.eaa.sections.startFromScratch.answer"
                )}
              </strong>
              {i18next.t(
                "pages.articles.list.eaa.sections.startFromScratch.contentAfter"
              )}
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.eaa.sections.whatToDo.title")}
            </h2>
            <ol className="list-decimal list-outside my-6 ml-8 mb-12">
              <li className="mb-4">
                <b>
                  {i18next.t(
                    "pages.articles.list.eaa.sections.whatToDo.steps.1.title"
                  )}
                </b>{" "}
                <br />
                {i18next.t(
                  "pages.articles.list.eaa.sections.whatToDo.steps.1.content"
                )}
              </li>
              <li className="mb-4">
                <b>
                  {i18next.t(
                    "pages.articles.list.eaa.sections.whatToDo.steps.2.title"
                  )}
                </b>
                <br />{" "}
                {i18next.t(
                  "pages.articles.list.eaa.sections.whatToDo.steps.2.content"
                )}
              </li>
              <li className="mb-4">
                <b>
                  {i18next.t(
                    "pages.articles.list.eaa.sections.whatToDo.steps.3.title"
                  )}
                </b>{" "}
                <br />
                {i18next.t(
                  "pages.articles.list.eaa.sections.whatToDo.steps.3.content"
                )}
              </li>
            </ol>
            <p>
              {i18next.t("pages.articles.list.eaa.sections.whatToDo.xperHelp")}
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.eaa.sections.conclusion.title")}
            </h2>
            <p>
              <a
                href="/skjema/kontakt-oss"
                className="font-bold underline hover:text-contrast-ink"
              >
                {i18next.t("pages.articles.list.eaa.sections.conclusion.cta")}
              </a>
              {i18next.t(
                "pages.articles.list.eaa.sections.conclusion.ctaFollow"
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErDinBedriftKlar;
